// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manjari:wght@100;400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manjari:wght@100;400;700&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

p {
  margin-bottom: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0;
}

.modal-dialog{
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.row > * {
  padding: 0px;
}

.homepage {
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.arrow-icon {
  color: #282828;
  border-radius: 50%;
  font-weight: 400;
  border: 1px solid #D9D9D9;
  font-size: 30px;
  padding: 5px;
  margin-right: 0px;
}

.app-main {
  display: flex;
  flex-direction: column;
  background-color: #0D1723;
}

.property-main::-webkit-scrollbar {
 display: none;
}

tr::-webkit-scrollbar{
  display: none;
}

.homepage-main {
  display: grid;
  grid-template-columns: 1fr 5fr;
  height: 100vh;
  background-color: #0D1723;
}

.property-main {
  margin-top: 80px;
  background-color: black;
  padding: 20px 40px;
  border-top-left-radius: 30px;
  background-color: #f7f7f7 !important;
  flex: 1 1;
  overflow-y: auto;
}

tr{
  text-align: center;
}

.property-details {
  padding: 16px;
  background-color: #f7f7f7 !important;
  border-top-right-radius: 30px;
}

.property-card {
  width: 100%;
  cursor: pointer;
  transition: transform 0.3s ease;
  height: 100%;
}

.property-card:hover {
  transform: scale(1.05);
}

.property-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.selected-card {
  border: 2px solid #007bff;
}

.image-preview img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  margin: 5px;
}

.flex-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-left{
  display: flex;
  justify-content: left;
  align-items: center;
}

.flex-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Manjari:wght@100;400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Manjari:wght@100;400;700&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\np {\n  margin-bottom: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 0;\n}\n\n.modal-dialog{\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.row > * {\n  padding: 0px;\n}\n\n.homepage {\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\n.arrow-icon {\n  color: #282828;\n  border-radius: 50%;\n  font-weight: 400;\n  border: 1px solid #D9D9D9;\n  font-size: 30px;\n  padding: 5px;\n  margin-right: 0px;\n}\n\n.app-main {\n  display: flex;\n  flex-direction: column;\n  background-color: #0D1723;\n}\n\n.property-main::-webkit-scrollbar {\n display: none;\n}\n\ntr::-webkit-scrollbar{\n  display: none;\n}\n\n.homepage-main {\n  display: grid;\n  grid-template-columns: 1fr 5fr;\n  height: 100vh;\n  background-color: #0D1723;\n}\n\n.property-main {\n  margin-top: 80px;\n  background-color: black;\n  padding: 20px 40px;\n  border-top-left-radius: 30px;\n  background-color: #f7f7f7 !important;\n  flex: 1;\n  overflow-y: auto;\n}\n\ntr{\n  text-align: center;\n}\n\n.property-details {\n  padding: 16px;\n  background-color: #f7f7f7 !important;\n  border-top-right-radius: 30px;\n}\n\n.property-card {\n  width: 100%;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  height: 100%;\n}\n\n.property-card:hover {\n  transform: scale(1.05);\n}\n\n.property-image {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n}\n\n.selected-card {\n  border: 2px solid #007bff;\n}\n\n.image-preview img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n  margin: 5px;\n}\n\n.flex-center{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-left{\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n.flex-between{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
